import React, { useEffect, useRef, useState } from "react";

// Style //
import "./TrainingMatrix.css";

// Images //
import { icons } from "../../assets/index";

// Table //
import Table from "react-bootstrap/Table";

// Components //
import {
  ButtonComp,
  PageHeading,
  TableRowLoader,
} from "../../common/components/index";
import { checkTicketStatus, dateFormateFullMonth } from "../../constents";

// Hooks //
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// API's //
import {
  downloadTrainingMatrixExcelApi,
  getTrainingMatrixApi,
} from "../../api/trainingMatrixApis";

// Actions //
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../redux/actions/utilsActions";

const TrainingMatrix = () => {
  // Hooks //
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pdfContentRef = useRef();
  const { userToken } = useSelector((state) => state.user);
  const { loading } = useSelector((state) => state.utils);

  const [trainingMatrixData, setTrainingMatrixData] = useState([]);
  const [ticketsData, setTicketsData] = useState([]);

  useEffect(() => {
    getAllTicketsData();
  }, []);

  const getAllTicketsData = async () => {
    try {
      dispatch(requestSent());
      const data = await getTrainingMatrixApi(userToken);
      console.log("dataaaaaaaaaa", data)
      setTicketsData(data.tickets);
      setTrainingMatrixData(data.trainingMatrix);
      dispatch(responseRecived());
    } catch (err) {
      dispatch(receivedError(err));
    }
  };

  const handleExportPdfHandler = async () => {
    try {
      dispatch(requestSent());
      const data = await downloadTrainingMatrixExcelApi(userToken);
      
      const fileurl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = fileurl;
      link.setAttribute('download', `training-matrix.xlsx`);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup: revoke the object URL and remove the link element
      window.URL.revokeObjectURL(fileurl);
      document.body.removeChild(link);
      dispatch(responseRecived());
    } catch (err) {
      dispatch(receivedError(err))
    }
  };

  return (
    <>
      <PageHeading
        title={"Training Matrix"}
        paragraph={"View your training matrix for your sub-contractors here."}
      />

      <div className="d-flex gx-5 justify-content-between align-items-center my-3 w-50">
        <ButtonComp
          onClick={handleExportPdfHandler}
          title={"Export To PDF"}
          width={"49%"}
          bgColor={"white"}
          style={{
            color: "black",
            marginRight: "5px",
            border: "1px solid black",
            padding: "1rem",
          }}
        />
        <ButtonComp
          onClick={() => navigate("edit-training-matrix/")}
          title={"Add / Edit / Delete"}
          width={"49%"}
          style={{ padding: "1rem" }}
        />
      </div>
      <div ref={pdfContentRef}>
        {loading ? (
          <TableRowLoader limit={8} />
        ) : (
          <div className="training_matrix_table_cont">
            <Table className="training_martix_table" bordered>
              <thead className="stickTop" style={{ zIndex: 4 }}>
                <tr>
                  <th className="bg-secondary stick1">
                    <img
                      className="table_icon"
                      src={icons.subContractor}
                      alt=""
                    />
                  </th>
                  {ticketsData?.map((item, index) => (
                    <th key={index} className="bg-secondary text-light training-matrix-header">
                      <p>{item?.name}</p>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!trainingMatrixData.length ? <td colSpan={ticketsData.length + 1} style={{ fontSize: '1rem', textAlign:'center' }}>No Data found</td> : trainingMatrixData?.map((item) => (
                  <tr key={item.id}>
                    <td className="stick1 bg-white">
                      {item?.SoleTraderProfile ? (
                        <b>{`${item?.SoleTraderProfile?.firstname} ${item?.SoleTraderProfile?.surname}`}</b>
                      ) : (
                        <b>{item?.email}</b>
                      )}
                    </td>

                    {ticketsData?.map((elem, index) => (
                      <td key={index}>
                        {item?.SoleTraderTickets?.filter(
                          (filteredticket) =>
                            filteredticket?.Ticket?.name === elem?.name
                        )?.map((ticket, index) => {
                          return (
                            <p
                              key={index}
                              className={`tickets-date ${ticket?.expiry_date && checkTicketStatus(ticket?.expiry_date)}`}
                            >
                              {ticket.expiry_date && dateFormateFullMonth(ticket.expiry_date)}
                            </p>
                          );
                        })}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}

        <div className="indicators_cont">
          <div className="indicators i-1">
            <span></span>
            <p>EXPIRED</p>
          </div>
          <div className="indicators i-2">
            <span></span>
            <p>EXPIRING SOON</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrainingMatrix;
